export const GET_LINKED_FAQS_BY_SLUG_METHOD = (slug: string, skip: number, preview: boolean) => `
  query {
    faqCollection(limit:10, skip:${skip}, preview:${preview}, where: {faqOwnerPage:{slug: "${slug}"}}) {
      total
      items {
        slug
        question
        answer {
          json
          links {
            entries {
              hyperlink {
                ... on Page {
                  sys {
                    id
                  }
                  slug
                  content {
                    __typename
                  }
                }
                ... on FileBlock {
                  sys {
                    id
                  }
                  imageVaultFile
                  metaData
                  __typename
                }
              }
            }
          }
        }
      }
    }
  }
`;
